import SpaceSize from "./SpaceSize";

export default SpaceSize;
